export default __webpack_public_path__ + "static/media/desktop_logo.53e8bc51.svg";